export default {
  computed: {
    backgroundStyle () {
      return this.$route.meta.background ? {
        'background-image': `url(${this.$route.meta.background})`,
        'background-attachment': 'fixed',
        'background-position': 'top',
        'background-repeat': 'no-repeat',
        'background-size': '100% auto'
      } : {};
    }
  }
};
